import React from 'react';
import { Helmet } from 'react-helmet';
import { getLanguages } from '../i18n/registry';
import { useLocale } from '../i18n/LocaleContext';
import { LOCALIZED_PATHS, localizedPath, unlocalizedPath } from '../i18n/routes';
import { serializeStructuredData } from '../content/home';

const SEO = ({ title, description, canonicalPath = '/', noindex = false, structuredData }) => {
  const { locale, language, t } = useLocale();
  const siteUrl = 'https://www.noteician.com';
  const originalPath = unlocalizedPath(canonicalPath);
  const hasTranslation = LOCALIZED_PATHS.includes(originalPath);
  const canonical = hasTranslation ? localizedPath(originalPath, locale) : originalPath;
  const pageTitle = title ? `${title} | Noteician` : 'Noteician';
  const pageDescription = description || t('seo.home');
  return (
    <Helmet>
      <html lang={locale} dir={language.direction} />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Noteician" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={`${siteUrl}${canonical}`} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <link rel="canonical" href={`${siteUrl}${canonical}`} />
      {noindex && <meta name="robots" content="noindex,follow" />}
      {hasTranslation && getLanguages('marketing').map(({ code }) => (
        <link key={code} rel="alternate" hrefLang={code} href={`${siteUrl}${localizedPath(originalPath, code)}`} />
      ))}
      {hasTranslation && <link rel="alternate" hrefLang="x-default" href={`${siteUrl}${originalPath}`} />}
      {structuredData && <script type="application/ld+json">{serializeStructuredData(structuredData)}</script>}
    </Helmet>
  );
};

export default SEO;
